import axios from "axios";

export const deleteCommentApi = (commentId: number) => {
  return axios.delete(`/comments/admin/${commentId}`);
};
